import * as React from 'react';
import { GdsAggregationServiceGroup, GdsAggregationServiceMeal } from '../../../../../types';
import { Meal } from '../../../../../../CheckoutAdditionalService/components';
import { groupGdsSelectedServices } from '../utils';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';

interface Props {
	segmentId?: string;
	service?: GdsAggregationServiceGroup;
	hideCard?: boolean;
}

const AggregatedMeal: React.FC<Props> = ({ segmentId, service, hideCard }) => {
	const { t } = useTranslation('ServiceAggregation');
	const theme = useTheme('Checkout').ServicesAggregationPage;

	const selectedServices = groupGdsSelectedServices<GdsAggregationServiceMeal>(service);
	const icons = ['Services/Meal 2', 'Flight/Direction'];

	return (
		<Meal
			minPrice={service.minPrice}
			totalPrice={service.totalPrice}
			aggregationMode={true}
			segmentId={segmentId}
			isSelected={!!service.selectedServices.length}
			aggregationIcons={icons}
			className={cn({
				[theme.hideServiceCard]: hideCard
			})}
		>
			{selectedServices.map(service => {
				return (
					<div key={service.service.rfics}>
						{service.service.name} - {service.count} {t('dish', { count: service.count })}
					</div>
				);
			})}
		</Meal>
	);
};

export default AggregatedMeal;
